export default {
  computed: {
    schema() {
      const mGolonganPns = Object.keys(this.masters['golongan'] || {})
        .filter((kGolongan) => (![-1, -2].includes(+kGolongan) && +kGolongan < 21) || +kGolongan === 99)
        .map((kGolongan) => {
          return {
            text: this.masters['golongan'][kGolongan],
            value: Number(kGolongan),
          };
        });

      return [
        {
          type: 'VRadio',
          name: 'k_pegawai_psp',
          label: 'Status Kepegawaian',
          hint: 'wajib diisi',
          required: true,
          items: [
            { text: 'PNS', value: 50001 },
            { text: 'Bukan PNS', value: 50002 },
          ],
          grid: { cols: 12, md: 6 },
        },
        {
          exist: { status: +this.form.k_pegawai_psp === 50001 },
          type: 'VTextField',
          name: 'nip',
          label: 'NIP',
          labelColor: 'info',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '####################',
          required: +this.form.k_pegawai_psp === 50001,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          exist: { status: +this.form.k_pegawai_psp === 50001 },
          type: 'VSelect',
          name: 'k_golongan',
          label: 'Pangkat/Golongan',
          labelColor: 'info',
          hint: 'wajib diisi',
          items: mGolonganPns,
          itemText: 'text',
          itemValue: 'value',
          required: +this.form.k_pegawai_psp === 50001,
          outlined: true,
          dense: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VTextField',
          name: 'npwp',
          label: 'NPWP',
          labelColor: 'info',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '####################',
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VAutocomplete',
          name: 'rekening_bank',
          label: 'Nama Bank (diutamakan Bank Nasional)',
          labelColor: 'info',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.masters['bank'], true),
          itemText: 'text',
          itemValue: 'value',
          required: true,
          hideDetails: true,
          outlined: true,
          dense: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VTextField',
          name: 'rekening_cabang',
          label: 'Cabang Bank',
          labelColor: 'info',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VTextField',
          name: 'rekening_nomor',
          label: 'Nomor Rekening',
          labelColor: 'info',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '####################',
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VTextField',
          name: 'rekening_nama',
          label: 'Nama di Akun Bank',
          labelColor: 'info',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
      ];
    },
  },
};
